export default {
  hideCompletedEventList: 'Skryť dokončené udalosti',
};
